import styled, { css } from 'styled-components';

const MenuStyled = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
`;

const SideNavStyled = styled.nav`
  background: #381451;
  border-radius: 10px;
`;

const MenuBodyContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  height: calc(100% - 88px - 75px);
  padding: 24px 16px;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0px;

  @media (min-width: 769px) {
    height: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0px 2px 4px 0px #0e141d26;
  }
`;

const SeparatorStyled = styled.div`
  margin: 8px;
  display: block;
  height: 1px;
  background-color: #c9cfd7;
  margin-top: 24px;
`;

const MenuBodyCategoryStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
  max-height: 40px;

  color: #0e141d;

  ${({ active }) =>
    active &&
    css`
      color: #4d008c;
    `}
`;

const MenuEntryStyled = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 8px;
  min-height: 40px;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;

  :hover {
    cursor: pointer;
    background: #e2e6ea;
  }
`;

const AccordionContainerStyled = styled.div`
  padding-right: 8px;
  padding-left: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  :hover {
    cursor: pointer;
  }
`;

const MenuBodySubCategoryStyled = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  padding: 8px 40px 8px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  gap: 8px;
  :hover {
    cursor: pointer;
    background: #e2e6ea;
  }
  :last-child {
    margin-bottom: 0px;
  }
`;

const MenuBodySubCategoryInfoContainerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  div:first-child {
    min-width: 24px;
    max-height: 24px;
  }

  span {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #0e141d;
    white-space: nowrap;
  }

  img {
    max-width: 24px;
    max-height: 24px;
  }
  ${({ active }) =>
    active
      ? css`
          span {
            color: #4d008c;
          }
        `
      : css`
          img {
            filter: sepia(100%) hue-rotate(150deg) saturate(200%)
              brightness(90%) contrast(90%);
          }
        `}
`;

const BottomPaddingContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  flex-grow: 1;
`;

const FooterContainerStyled = styled.div`
  background: #eff1f3;
  padding: 24px 0px 32px 0px;
  min-height: 124px;
  width: 100%;
  display: flex;
  justify-content: center;
  width: calc(100% + 32px);
  margin-left: -16px;
  border-top: 1px solid #c9cfd7;
  margin-top: auto;

  @media (min-width: 769px) {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    // margin-top: 16px;
  }
`;

export {
  MenuStyled,
  SideNavStyled,
  MenuBodyContainerStyled,
  SeparatorStyled,
  MenuBodyCategoryStyled,
  MenuEntryStyled,
  AccordionContainerStyled,
  MenuBodySubCategoryStyled,
  MenuBodySubCategoryInfoContainerStyled,
  BottomPaddingContainerStyled,
  FooterContainerStyled,
};
